import { fetchWithAuth } from "../api/client";
import { ExportableSurvey, ExportHistoryItem } from "../types";

export type ExportParams = {
  surveyId: string;
  responseType?: "all" | "child" | "family";
  startDateUtc?: string | null;
  endDateUtc?: string | null;
  language: "es" | "ca" | "en" | "ar";
};

export async function exportSurveyExcel(
  token: string,
  params: ExportParams
): Promise<Blob> {
  const body = {
    surveyId: params.surveyId,
    respondentType:
      params.responseType === "child"
        ? 0
        : params.responseType === "family"
        ? 1
        : null,
    startDateUtc: params.startDateUtc || null,
    endDateUtc: params.endDateUtc || null,
    language: params.language,
  };

  const res = await fetchWithAuth("SurveySubmissions/export-dataurl", {
    method: "POST",
    token,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const msg = await res.text();
    throw new Error(msg || `Error export: ${res.status}`);
  }

  // Obtener el blob del archivo Excel
  return await res.blob();
}

export async function getExportableSurveys(
  token: string,
  params: {
    language: "es" | "ca" | "en" | "ar";
    responseType?: "all" | "child" | "family";
    startDate?: string;
    endDate?: string;
  }
): Promise<ExportableSurvey[]> {
  const qs = new URLSearchParams();
  qs.set("language", params.language);

  if (params.responseType && params.responseType !== "all") {
    const respondentType = params.responseType === "child" ? "0" : "1";
    qs.set("respondentType", respondentType);
  }
  if (params.startDate) {
    qs.set("startDateUtc", new Date(params.startDate).toISOString());
  }
  if (params.endDate) {
    qs.set("endDateUtc", new Date(params.endDate).toISOString());
  }

  const res = await fetchWithAuth(
    `SurveySubmissions/exportable?${qs.toString()}`,
    {
      method: "GET",
      token,
    }
  );
  if (!res.ok)
    throw new Error(`Error fetching exportable surveys: ${res.statusText}`);
  const data = await res.json();
  return data.map((x: ExportableSurvey) => ({
    id: x.id,
    title: x.title,
    responses: x.responses ?? 0,
    lastSubmissionAt: x.lastSubmissionAt ?? null,
  }));
}
export async function getExportHistory(
  token: string,
  params: { language: "es" | "ca" | "en" | "ar"; limit?: number }
): Promise<ExportHistoryItem[]> {
  const qs = new URLSearchParams();
  qs.set("language", params.language);
  if (params.limit) qs.set("limit", String(params.limit));

  const res = await fetchWithAuth(
    `SurveySubmissions/export-history?${qs.toString()}`,
    {
      method: "GET",
      token,
    }
  );
  if (!res.ok)
    throw new Error(`Error fetching export history: ${res.statusText}`);
  return res.json();
}
